<div class="relative inline-block">
  <button
    type="button"
    class="flex items-center gap-2 rounded-3xl border border-lGray700 bg-lGray900 px-6 py-1.5 text-lg font-light text-lWhite transition-all duration-200 hover:bg-lGray800"
    (click)="toggleOpen()"
  >
    <l-icon class="text-xl">filter_alt</l-icon>
    <span>Filtro</span>
  </button>

  @if (open) {
    <div
      class="absolute right-0 top-full z-50 mt-3 flex w-[540px] max-w-[calc(100vw-2rem)] flex-col gap-7 rounded-[28px] bg-lGray900 p-8 shadow-modal"
      lOutsideClick
      (outsideClick)="close()"
      (click)="$event.stopPropagation()"
    >
      <header class="flex items-center justify-between">
        <h3 class="text-base font-semibold text-lWhite">Filtro</h3>

        <button type="button" class="transition-opacity hover:opacity-75" (click)="close()">
          <l-icon class="cursor-pointer text-xl text-lWhite">close</l-icon>
        </button>
      </header>

      <fieldset class="m-0 flex min-w-0 flex-col gap-4 border-0 p-0">
        <legend class="text-sm font-medium text-lWhite">Status</legend>

        <div class="flex items-center gap-1 rounded-full bg-lGray700 p-2">
          @for (status of statusOptions; track status.value) {
            <button
              type="button"
              class="flex h-10 flex-1 items-center justify-center gap-2 rounded-full px-4 text-sm font-medium transition-all duration-200 hover:bg-lWhite/5"
              [ngClass]="{
                'bg-lWhite light:bg-white text-lPrimary translate-y-[-1px] hover:bg-lWhite light:hover:bg-white': isSelected(status.value),
                'text-lSecondary hover:text-lWhite': !isSelected(status.value)
              }"
              [style.box-shadow]="isSelected(status.value) ? 'var(--lShadowPopover)' : 'none'"
              (click)="selectStatus(status.value)"
            >
              <l-icon class="text-sm transition-colors duration-200" [class.text-lPrimary]="isSelected(status.value)" [class.text-lGray500]="!isSelected(status.value)">{{ status.icon }}</l-icon>
              <span>{{ status.label }}</span>
            </button>
          }
        </div>
      </fieldset>

      <fieldset class="m-0 flex min-w-0 flex-col gap-4 border-0 p-0">
        <legend class="text-sm font-medium text-lWhite">Categoria</legend>

        <div class="relative" lOutsideClick (outsideClick)="categoryDropdownOpen = false" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="flex h-12 w-full items-center justify-between rounded-full bg-lGray700 px-4 text-left text-sm text-lWhite transition-all duration-200 hover:bg-lGray600 light:hover:bg-lGray850 focus:ring-2 focus:ring-lPrimary"
            [class.opacity-50]="categoryDisabled"
            [class.cursor-not-allowed]="categoryDisabled"
            [disabled]="categoryDisabled"
            (click)="toggleCategoryDropdown()"
          >
            <span class="truncate" [class.text-lWhite]="draftSelectedCategories && draftSelectedCategories.length > 0" [class.text-lSecondary]="!draftSelectedCategories || draftSelectedCategories.length === 0">{{ getCategoryLabel() }}</span>
            <l-icon class="text-xl text-lWhite/80 transition-transform duration-200" [class.rotate-180]="categoryDropdownOpen">keyboard_arrow_down</l-icon>
          </button>

          @if (categoryDropdownOpen && !categoryDisabled) {
            <div class="absolute left-0 right-0 top-full z-50 mt-2 max-h-64 overflow-auto rounded-2xl bg-lGray700 p-2 shadow-popover">
              <button
                type="button"
                class="flex w-full items-center justify-between rounded-xl px-4 py-3 text-left text-sm text-lWhite transition-colors duration-200 hover:bg-lWhite/10"
                [class.bg-lGray900]="draftSelectedCategories && draftSelectedCategories.length === 0"
                (click)="clearSelectedCategories()"
              >
                <span>Todas</span>
                @if (draftSelectedCategories && draftSelectedCategories.length === 0) {
                  <l-icon class="text-base text-lWhite">check</l-icon>
                }
              </button>

              @for (category of categories; track category.id) {
                <button
                  type="button"
                  class="flex w-full items-center justify-between rounded-xl px-4 py-3 text-left text-sm text-lWhite transition-colors duration-200 hover:bg-lWhite/10"
                  [class.bg-lGray900]="isCategorySelected(category.id)"
                  (click)="selectCategory(category)"
                >
                  <span class="truncate">{{ category.name }}</span>
                  @if (isCategorySelected(category.id)) {
                    <l-icon class="text-base text-lWhite">check</l-icon>
                  }
                </button>
              }

              @if (categories.length === 0) {
                <div class="px-4 py-3 text-sm text-lSecondary">Nenhuma categoria disponível</div>
              }
            </div>
          }
        </div>
      </fieldset>

      <fieldset class="m-0 flex min-w-0 flex-col gap-4 border-0 p-0">
        <legend class="text-sm font-medium text-lWhite">Data de criação</legend>

        <div class="w-full">
          <p-calendar
            [(ngModel)]="draftDateRange"
            selectionMode="range"
            [readonlyInput]="true"
            [showIcon]="true"
            iconDisplay="input"
            [disabled]="dateDisabled"
            placeholder="Selecione o período"
            dateFormat="dd/mm/yy"
          />
        </div>
      </fieldset>

      <footer class="mt-2 flex gap-4">
        <button lButton [bType]="buttonTypeEnum.OUTLINE" [bRadius]="buttonRadiusEnum.CIRCLE" class="flex-1 py-3 shadow-none" (click)="clearFilter()">Limpar filtro</button>

        <button lButton [bType]="buttonTypeEnum.PRIMARY" [bRadius]="buttonRadiusEnum.CIRCLE" class="flex-1 py-3 shadow-none" (click)="applyFilter()">Aplicar</button>
      </footer>
    </div>
  }
</div>